import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfTrashIconProps extends SvgIconProps {
  fillColor?: string;
}
/**
 * Component used to display  align center Icon
 * @param props - CcfAcdIconProps
 * @example - <CcfAcdIcon />
 * @returns SVG of align center Icon
 */
export function CcfTrashIcon(props: CcfTrashIconProps) {
  return (
    <SvgIcon
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 4H16V0H4V4H1C0.4 4 0 4.5 0 5C0 5.5 0.4 6 1 6H2.2L3.5 18.3C3.5 19.3 4.2 20 5 20H15C15.8 20 16.5 19.3 16.5 18.3L17.7 6H19C19.5 6 20 5.5 20 5C20 4.5 19.6 4 19 4ZM6 2H14V4H6V2ZM14.5 18H5.5L4.2 6H15.7L14.5 18Z"
        fill={props?.fillColor || '#3F5C69'}
      />
      <path d="M7 8H9V15H7V8Z" fill={props?.fillColor || '#3F5C69'} />
      <path d="M11 8H13V15H11V8Z" fill={props?.fillColor || '#3F5C69'} />
    </SvgIcon>
  );
}

export default CcfTrashIcon;
